// Package imports
import React from 'react';

// CSS imports
import './SearchBar.css';

// Component imports
import TextInput from '../inputs/textInput/TextInput';
import PrimaryButton from '../buttons/primaryButton/PrimaryButton';

// Icons
import { BiSearch } from 'react-icons/bi';

type Props = {
  value: string;
  placeholder?: string;
  className?: string;
  onChange: (e: any) => void;
  triggerSearch: (x: string) => void;
};

const SearchBar: React.FC<Props> = ({
  value,
  placeholder,
  className,
  onChange,
  triggerSearch,
}) => {
  const handleKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      // Trigger search
      triggerSearch(value);
    }
  };
  return (
    <div className={`SearchBar ${className}`}>
      <TextInput
        value={value}
        name='search'
        onChange={onChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className='search-input'
      />
      <PrimaryButton
        ReactIcon={BiSearch}
        onClick={() => triggerSearch(value)}
        className='search-button'
      />
    </div>
  );
};

export default SearchBar;
